import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../AllMotoModels.css';
import { sendFrontAction } from '../services/api'; 

const AllMotoModels = () => {
    const [motoModels, setMotoModels] = useState([]); 
    const [activeTab, setActiveTab] = useState('Все'); 
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const TABS = ['Все', 'Sport', 'M', 'Tour', 'Roadster', 'Adventure'];

    useEffect(() => {
        window.scrollTo(0, 0);

        sendFrontAction('motorrad_catalog', {}, 'GET')
            .then(responseData => {
                if (responseData && responseData.success && Array.isArray(responseData.data)) {
                    setMotoModels(responseData.data);
                }
                setLoading(false);
            })
            .catch(error => {
                console.error("Ошибка при загрузке каталога:", error);
                setLoading(false);
            });
    }, []);

    const categoriesToRender = activeTab === 'Все' 
        ? ['Sport', 'M', 'Tour', 'Roadster', 'Adventure'] 
        : [activeTab];

    if (loading) {
        return <div className="loading-container">Загрузка модельного ряда...</div>;
    }

    return (
        <div className="all-models-page">
            <header className="models-nav">
                <ul className="filter-tabs">
                    {TABS.map((tab) => (
                        <li 
                            key={tab} 
                            className={activeTab === tab ? 'active' : ''} 
                            onClick={() => setActiveTab(tab)}
                        >
                            {tab}
                        </li>
                    ))}
                </ul>
            </header>

            {categoriesToRender.map((cat) => {
                // Поддерживаем как Category, так и category
                const modelsInCurrentCategory = motoModels.filter(
                    m => (m.Category || m.category) === cat
                );

                if (modelsInCurrentCategory.length === 0) return null;

                return (
                    <section key={cat} className="category-section">
                        <h2 className="category-title">{cat}</h2>
                        <div className="models-list-grid">
                            {modelsInCurrentCategory.map((model) => {
                                // Безопасное извлечение картинки, наименования и slug
                                const imageUrl = model.bike_image || model.bikeImage || model.mainImage || '/assets/placeholder.jpg';
                                const modelName = model.bikeModel || model.name;
                                const modelSlug = model.slug || model.id;

                                return (
                                    <div 
                                        key={model.id} 
                                        className="model-item"
                                        // 🔥 Переход строго по маршруту /motorrad/{slug}
                                        onClick={() => navigate(`/motorrad/${modelSlug}`)} 
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <div className="image-wrapper">
                                            <img 
                                                src={imageUrl}
                                                className={`main-photo ${modelName?.includes('M 1000 RR') ? 'special-style' : ''}`}
                                                alt={modelName} 
                                            />
                                        </div>
                                        <p className="model-name-label">{modelName}</p>
                                    </div>
                                );
                            })}
                        </div>
                    </section>
                );
            })}
        </div>
    );
};

export default AllMotoModels;